<!--
    描述：清单检查 tab 页
    时间：2020-08-19
    Created by ws
-->
<template>
    <w-split v-model="splitV" class="inventory-main">
        <!-- 左侧结构树 -->
        <left-structure slot="left" :editable="false" :showCheckbox="true" ref="leftTree" @rowClick="leftRowClick" @onCheck="checkChange"></left-structure>
        <!-- 右侧表格 -->
        <div class="w-strucutre-layout" slot="right">
            <div class="w-strucutre-header">
                <span class="title pdl10 text-overflow">
                    <el-tooltip class="item" effect="dark" :content="curName" placement="bottom-start">
                        <span>{{ curName }}</span>
                    </el-tooltip>
               	</span>
                <div class="btnGroups">
                    <el-button size="small" icon="el-icon-sort" class="ml10" type="" @click="doSort">联合排序
                    </el-button>
                    <el-button size="small" icon="el-icon-sort" class="ml10" :type="showAllData ? 'danger' : 'success'" @click="changeTableType">{{ showAllData ? "异常数据" : "全部数据" }}
                    </el-button>
                    <el-button size="small" icon="el-icon-refresh" class="ml10" type="warning" @click="doRefresh">重置
                    </el-button>
                    <el-button size="small" icon="el-icon-menu" class="ml10" type="primary" @click="doFilter">列过滤
                    </el-button>
                    <el-button plain size="small" type="primary" icon="el-icon-download" v-if="roleBtns.includes('inv-Excel') || curSource === '1'" @click="doExport('excel')">导出Excel
                    </el-button>
                    <el-button size="small" icon="el-icon-upload" v-if="roleBtns.includes('inv-Html') || curSource === '1'" @click="doExport('html')">导出Html
                    </el-button>
                </div>
            </div>
            <div class="w-structure-content" v-loading="sheetLoading">
                <w-split v-model="splitH" max="40" min="0">
                    <div class="h100" slot="left">
                        <inventory-table ref="inventoryTable" :searchForm="queryParams" @rowClick="rightRowClick"></inventory-table>
                    </div>
                    <div class="h100" slot="right" v-if="drawerObj.showSplit">
                        <w-split v-model="drawerObj.splitD" mode="vertical">
                            <div class="pane-split pdt0" slot="top">
                                <el-table :data="drawerObj.quotaData" border highlight-current-row size="small" ref="quotaTable" @row-click="quotaClick" height="100%">
                                    <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                                    <el-table-column prop="name" label="定额名称" min-width="350" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
                                    <el-table-column prop="quantity" label="数量" width="90" show-overflow-tooltip header-align="center" align="right">
                                        <template slot-scope="scope">
                                            <div>{{ scope.row.quantity ? scope.row.quantity.toFixed(3) : '0.000' }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="laborRate" label="人工单价" width="100" show-overflow-tooltip header-align="center" align="right">
                                        <template slot-scope="scope">
                                            <div>{{ scope.row.laborRate ? scope.row.laborRate.toFixed(2) : '0.00' }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="materialRate" label="材料单价" width="100" show-overflow-tooltip header-align="center" align="right">
                                        <template slot-scope="scope">
                                            <div>
                                                {{ scope.row.materialRate ? scope.row.materialRate.toFixed(2) : '0.00' }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="machineRate" label="机械单价" width="100" show-overflow-tooltip header-align="center" align="right">
                                        <template slot-scope="scope">
                                            <div>{{ scope.row.machineRate ? scope.row.machineRate.toFixed(2) : '0.00' }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="rate" label="综合单价" width="100" show-overflow-tooltip header-align="center" align="right">
                                        <template slot-scope="scope">
                                            <div>{{ scope.row.rate ? scope.row.rate.toFixed(2) : '0.00' }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="overheadRate" label="管理费" width="100" show-overflow-tooltip header-align="center" align="right">
                                        <template slot-scope="scope">
                                            <div>
                                                {{ scope.row.overheadRate ? scope.row.overheadRate.toFixed(2) : '0.00' }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="pane-split" slot="bottom">
                                <el-table :data="drawerObj.quotaChildren" border ref="quotaChildren" row-key="id" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}" size="small" height="100%">
                                    <!-- <el-table-column type="index"
											 label="序号"
											 width="70"></el-table-column> -->
                                    <el-table-column prop="code" label="编号" show-overflow-tooltip header-align="center" min-width="200"></el-table-column>
                                    <el-table-column prop="typeName" label="类别" align="center" width="80"></el-table-column>
                                    <el-table-column prop="name" label="名称" show-overflow-tooltip header-align="center" width="180"></el-table-column>
                                    <el-table-column prop="specification" label="规格" show-overflow-tooltip header-align="center" width="150"></el-table-column>
                                    <el-table-column prop="unit" label="单位" align="center" show-overflow-tooltip width="80"></el-table-column>
                                    <el-table-column prop="budgetRate" label="除税定额价" header-align="center" align="right" show-overflow-tooltip width="100">
                                        <template slot-scope="scope">
                                            <div>{{ scope.row.budgetRate ? scope.row.budgetRate.toFixed(2) : '0.00' }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="marketRate" label="除税价" header-align="center" align="right" show-overflow-tooltip width="100">
                                        <template slot-scope="scope">
                                            <div>{{ scope.row.marketRate ? scope.row.marketRate.toFixed(2) : '0.00' }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="uses" label="数量" header-align="center" align="right" show-overflow-tooltip width="100">
                                        <template slot-scope="scope">
                                            <div>{{ scope.row.uses ? scope.row.uses.toFixed(2) : '0.000' }}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="actualNum" label="实际数量" header-align="center" align="right" show-overflow-tooltip width="100">
                                        <template slot-scope="scope">
                                            <div>{{ scope.row.actualNum ? scope.row.actualNum.toFixed(2) : '0.000' }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="quotaPrice" label="定额合价" header-align="center" align="right" show-overflow-tooltip width="100">
                                        <template slot-scope="scope">
                                            <div>{{ scope.row.quotaPrice ? scope.row.quotaPrice.toFixed(2) : '0.00' }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="marketPrice" label="市场合价" header-align="center" align="right" show-overflow-tooltip width="100">
                                        <template slot-scope="scope">
                                            <div>{{ scope.row.marketPrice ? scope.row.marketPrice.toFixed(2) : '0.00' }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </w-split>
                    </div>
                </w-split>
            </div>
            <!-- 定额侧滑 -->
            <el-drawer :visible.sync="drawerObj.show" direction="rtl" :with-header="false" size="60%">
                <w-split v-model="drawerObj.splitD" mode="vertical">
                    <div class="pane-split" slot="top">
                        <el-table :data="drawerObj.quotaData" border highlight-current-row size="small" ref="quotaTable" @row-click="quotaClick" height="100%">
                            <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
                            <el-table-column prop="name" label="定额名称" min-width="350" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
                            <el-table-column prop="quantity" label="数量" width="90" show-overflow-tooltip header-align="center" align="right">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.quantity ? scope.row.quantity.toFixed(3) : '0.000' }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="laborRate" label="人工单价" width="100" show-overflow-tooltip header-align="center" align="right">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.laborRate ? scope.row.laborRate.toFixed(2) : '0.00' }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="materialRate" label="材料单价" width="100" show-overflow-tooltip header-align="center" align="right">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.materialRate ? scope.row.materialRate.toFixed(2) : '0.00' }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="machineRate" label="机械单价" width="100" show-overflow-tooltip header-align="center" align="right">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.machineRate ? scope.row.machineRate.toFixed(2) : '0.00' }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="rate" label="综合单价" width="100" show-overflow-tooltip header-align="center" align="right">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.rate ? scope.row.rate.toFixed(2) : '0.00' }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="overheadRate" label="管理费" width="100" show-overflow-tooltip header-align="center" align="right">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.overheadRate ? scope.row.overheadRate.toFixed(2) : '0.00' }}</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pane-split" slot="bottom">
                        <el-table :data="drawerObj.quotaChildren" border ref="quotaChildren" row-key="id" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}" size="small" height="100%">
                            <!-- <el-table-column type="index"
											 label="序号"
											 width="70"></el-table-column> -->
                            <el-table-column prop="code" label="编号" show-overflow-tooltip header-align="center" min-width="200"></el-table-column>
                            <el-table-column prop="typeName" label="类别" align="center" width="80"></el-table-column>
                            <el-table-column prop="name" label="名称" show-overflow-tooltip header-align="center" width="180"></el-table-column>
                            <el-table-column prop="specification" label="规格" show-overflow-tooltip header-align="center" width="150"></el-table-column>
                            <el-table-column prop="unit" label="单位" align="center" show-overflow-tooltip width="80"></el-table-column>
                            <el-table-column prop="budgetRate" label="除税定额价" header-align="center" align="right" show-overflow-tooltip width="100">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.budgetRate ? scope.row.budgetRate.toFixed(2) : '0.00' }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="marketRate" label="除税价" header-align="center" align="right" show-overflow-tooltip width="100">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.marketRate ? scope.row.marketRate.toFixed(2) : '0.00' }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="uses" label="数量" header-align="center" align="right" show-overflow-tooltip width="100">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.uses ? scope.row.uses.toFixed(2) : '0.000' }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="actualNum" label="实际数量" header-align="center" align="right" show-overflow-tooltip width="100">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.actualNum ? scope.row.actualNum.toFixed(2) : '0.000' }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="quotaPrice" label="定额合价" header-align="center" align="right" show-overflow-tooltip width="100">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.quotaPrice ? scope.row.quotaPrice.toFixed(2) : '0.00' }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="marketPrice" label="市场合价" header-align="center" align="right" show-overflow-tooltip width="100">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.marketPrice ? scope.row.marketPrice.toFixed(2) : '0.00' }}</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </w-split>
            </el-drawer>
        </div>
    </w-split>
</template>
<script>
// components
import leftStructure from '@/views/project-management/project-info/components/left_structure'
import inventoryTable from './inventory_table_new'
// import inventoryTable from './inventory_table'
import { mapState } from 'vuex'

// js
import {
    getCodeList,
    getCodesAndNames,
    getQuotaList,
    getQuotaChild
} from '@/api/modules/analysisInventory'
import { exportExcel, dateFormat } from '@/utils/tools'

export default {
    components: {
        leftStructure,
        inventoryTable
    },
    data() {
        return {
            splitV: 0.3,
            splitH: 1,
            sheetLoading: false, // 列表等待状态
            resData: {}, // 新动态返回的数据
            tableData: [],
            // 弹窗对象
            dialogObj: {
                title: '添加对比',
                visible: false,
                width: '90%',
                type: 'filter',
                exportExcel: false
            },
            // 侧滑对象
            drawerObj: {
                splitD: 0.3,
                show: false,
                showSplit: false,
                quotaData: [],
                quotaChildren: []
            },
            curName: '', // 当前点击的 结构树层级名称
            btnLoading: false,
            // 对比筛选数据
            compareFilter: [{
                    label: '清单特征',
                    key: 'projectFeatures'
                },
                {
                    label: '计量单位',
                    key: 'unit'
                },
                {
                    label: '工程量',
                    key: 'quantity'
                },
                {
                    label: '单价',
                    key: 'rateCost'
                },
                {
                    label: '合价',
                    key: 'addup'
                }
            ],
            compareArr1: [
                'projectFeatures',
                'unit',
                'quantity',
                'rateCost',
                'addup'
            ], // 最终筛选的 对比数组1
            // 导出、查询 参数对象
            queryParams: {
                projectId: '', // 项目ID
                treeIds: [], // 单位工程ID 数组
                phase: '', // 造价阶段
                type: 1, // 是六算或者 每一期进度款 （1 / 2）
                code: [], // 编码
                projectFeatures: '', // 清单特征
                projectName: '', // 清单名称
                unit: '', // 计量单位
                userName: 'xxx',
                unitQuery: 0
            },
            codeList: [], // 清单编码数组
            codeArr: [], // 所选的清单编码 数组
            checkAll1: true, // 全选按钮
            // 是否展示全部清单、异常清单
            showAllData: true
        }
    },
    created() {
        // this.$nextTick(() => {
        // 	this.getCodeTypeList()
        // })
    },
    methods: {
        // 左侧项目结构树点击事件
        leftRowClick(row) {
            // 项目名称 以及  当前层级名称
            let _pname = this.projectName
            let _name = row.sname

            // 第一级
            if (row.levelType === 0) {
                this.curName = _name
            } else if (row.levelType === 1) {
                this.curName = _pname + ' | ' + _name
            } else {
                let _dname = this.$refs.leftTree.tableData[0].children.find(
                    x => x.id === row.pid
                ).sname
                this.curName = _pname + ' | ' + _dname + ' | ' + _name
            }
        },

        // 复选框选择事件
        checkChange(arr) {
            if (this.$refs.inventoryTable) {
                this.queryParams.treeIds = arr
                let params = this.setParams()
                params.unitQuery = 0
                // this.$refs.inventoryTable.getTableData(params)
                // new
                this.loadDetailTable(params)

                // 获取名称和 编码数组
                this.getCodeTypeList(params)
            }
        },

        // 获取编码分类数组
        getCodeTypeList(params) {
            getCodesAndNames(params)
                .then(res => {
                    if (this.$refs.inventoryTable) {
                        // 清单名称过滤数组
                        this.$refs.inventoryTable.filterObj.nameList =
                            res.data.billNames

                        // 清单编码数组
                        let _list = this.$utils.toArrayTree(
                            res.data.billCodes, { parentKey: 'pid' }
                        )
                        // 删除多余的 children 空数组
                        this.$utils.eachTree(_list, item => {
                            if (item.children && item.children.length === 0) {
                                delete item.children
                            }
                        })
                        this.$refs.inventoryTable.filterObj.codeList = _list

                        // 单位数组
                        this.$refs.inventoryTable.filterObj.unitList =
                            res.data.billUnits
                    }
                })
                .catch(err => {})
        },

        // 加载表格
        loadDetailTable(params) {
            if (this.$refs.inventoryTable) {
                // 请求参数
                this.$refs.inventoryTable.queryParams = this.$utils.clone(params, true)

                this.$refs.inventoryTable.loadData()
            }
        },

        // 点击查询
        doSearch() {
            if (this.queryParams.treeIds.length === 0) {
                this.$message.info('请先从左侧选择 单位工程!')
                return
            }

            let params = this.setParams()
            params.unitQuery = 0
            // this.$refs.inventoryTable.getTableData(params)
            // new
            this.loadDetailTable(params)
        },

        // 联合排序
        doSort() {
            let params = this.setParams()
            params.unitQuery = 1

            // 先清除排序
            this.$refs.inventoryTable.clearSort()

            // 打开排序弹窗
            this.$refs.inventoryTable.openSort()

            // this.$refs.inventoryTable.getTableData(params)
            // new
            // this.loadDetailTable(params)
        },

        // 切换表格展示（全部清单、异常清单）
        changeTableType() {
            this.showAllData = !this.showAllData;
            this.$refs.inventoryTable ? this.$refs.inventoryTable.changeData(this.showAllData) : ''
        },

        // 点击重置
        onReset() {
            this.codeArr = []
            this.queryParams.projectName = ''
            this.queryParams.code = []
            this.queryParams.unit = ''
            this.queryParams.projectFeatures = ''

            // 清除过滤器
            if (this.$refs.inventoryTable) {
                this.$refs.inventoryTable.clearAll()
                // this.$refs.inventoryTable.clearSort()
            }
        },

        // 点加刷新
        doRefresh(val) {
            // 重置查询条件
            this.onReset()

            // 清除过滤器
            if (this.$refs.inventoryTable) {
                this.$refs.inventoryTable.clearFilter()
            }

            // 执行查询
            this.doSearch()
        },

        // 右侧表格行单击事件
        rightRowClick(row) {
            // this.drawerObj.show = true
            this.drawerObj.showSplit = true

            // 获取定额数据
            this.getQuotaData(row.id)
        },

        // 根据 清单ID 获取定额数据
        getQuotaData(rowId) {
            getQuotaList({
                    billId: rowId
                })
                .then(res => {
                    this.drawerObj.quotaData = res.data

                    if (res.data.length > 0 && this.$refs.quotaTable) {
                        this.$refs.quotaTable.setCurrentRow(res.data[0])
                        this.getQuotaChildren(res.data[0].id)
                    }
                })
                .catch(err => {
                    this.drawerObj.quotaData = []
                })
        },

        // 定额行点击事件
        quotaClick(row) {
            this.getQuotaChildren(row.id)
        },

        // 根据定额ID 获取数据
        getQuotaChildren(quotaId) {
            getQuotaChild({
                    quotaId: quotaId
                })
                .then(res => {
                    res.data.map(x => {
                        x.id = x.code + '-' + x.type
                        // 定额合价，市场合价 汇总
                        if (x.children) {
                            x.quotaPrice = 0
                            x.marketPrice = 0
                            x.children.map(y => {
                                x.quotaPrice += y.quotaPrice
                                x.marketPrice += y.marketPrice
                            })
                        }
                    })
                    this.drawerObj.quotaChildren = res.data
                })
                .catch(err => {
                    this.drawerObj.quotaChildren = []
                })
        },

        // 请求传值参数设置
        setParams() {
            // 项目ID
            this.queryParams.projectId = this.curProjectId
            // 造价阶段
            this.queryParams.phase = this.$refs.inventoryTable.priceType1
            this.queryParams.type = this.$refs.inventoryTable.getPhaseObj.type1

            // 排序字段
            let _sort = this.$refs.inventoryTable.sortArr.filter(x => x.visible)
            this.queryParams.sortField = _sort.map(x => x.key) || []
            // 编码
            this.queryParams.code = this.codeArr.map(x => x[x.length - 1])
            this.queryParams.userName = this.userName
            return this.queryParams
        },

        // 点击列过滤按钮
        doFilter() {
            if (this.$refs.inventoryTable) {
                this.$refs.inventoryTable.openFilter()
            }
        },

        // 点击导出 （0 是excel, 1 是html）
        doExport(type) {
            if (
                this.$refs.inventoryTable &&
                this.$refs.inventoryTable.getListData().length === 0
            ) {
                this.$message.info('暂时没有要导出的数据！')
                return
            }
            let saveName = '清单检查数据' + dateFormat('yyyy-MM-dd hh:ss:mm')
            let params = this.setParams()
            params.projectName = this.projectName
            params.exportType = type
            params.saveName = saveName
            params.totalSum = this.$refs.inventoryTable.totalSum
            params.list = this.$refs.inventoryTable.getListData() || []

            exportExcel(
                'busDetailedAnalysisApproval/checklistCheckExport',
                params,
                saveName
            )
        }
    },
    computed: {
        // 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
        curSource() {
            return this.$route.query.source || '0'
        },
        // 项目名称
        projectName() {
            return this.$route.query.projectName
        },

        // 项目ID
        curProjectId() {
            return this.$route.query.projectId
        },
        ...mapState('menu', {
            roleBtns: state => state.roleBtns
        }),

        // 用户名称
        ...mapState('user', {
            userName: state => state.userInfo.sname
        })
    },
    watch: {
        // 列过滤 是否 全选
        compareArr1(arr) {
            if (arr.length === this.compareFilter.length) {
                this.checkAll1 = true
            } else {
                this.checkAll1 = false
            }
        }
    }
}
</script>
<style scoped lang="less">
.inventory-main {
    .check-row {
        margin-bottom: 7px;
        // background-color: #a3e3ff;
        height: 35px;
        line-height: 35px;
        font-weight: 700;
        color: #333;

        .check-name {
            border-right: 3px solid #1d7f8a;
        }

        .check-content {
            text-align: left;
            padding-left: 15px;
        }
    }

    .check-row:nth-of-type(2) {
        background-color: #f5f5ad;
    }

    .check-row:nth-of-type(3) {
        background-color: #ffe4c4;
    }

    .check-row:nth-of-type(4) {
        background-color: #7fffd4;
    }

    .range-header {
        text-align: left;
        padding-left: 10px;
        height: 35px;
        line-height: 35px;
    }

    .range-content {
        padding: 10px;

        .range-row {
            display: flex;
            height: 40px;
            line-height: 40px;
            margin-bottom: 10px;
        }

        .range-row-name {
            display: flex;
            align-items: center;
            width: 100px;
        }

        .range-row-input {
            flex: 1;
            text-align: left;
        }
    }

    .pane-split {
        height: 100%;
        padding: 10px;
    }

    /deep/ tr.current-row::after {
        content: none;
    }
}
</style>